<template>
  <div class="wrapper flex">
    <!--    <p class="mb-3 compName">公司名称</p>-->
    <select v-model="item.companyId" class="select mb-3">
      <option v-for="(comp,i) in miniCompanies" :key="i" :value="comp.value">{{ comp.text }}</option>
    </select>
    <textarea v-model="item.description" placeholder="请输入事项描述"></textarea>
    <div class="spacer"></div>
    <!--<button block class="info outline mb-3">仅保存</button>-->
    <button block class="info" @click="submit">提交</button>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: "TaskForm",
    computed: {
      ...mapGetters(['miniCompanies'])
    },
    methods: {
      ...mapActions(['fetchMiniCompanies', 'saveTask']),
      submit() {
        //提交表单
        this.saveTask({
          item: this.item,
          cb: (res) => {
            this.$router.replace({
              name:'tasks'
            })
          }
        });
      },
    },
    data(){
      return {
        item: {
          description: null,
          companyId: null,
          progress: '已创建'
        }
      }
    },
    created() {
      window.document.title = '新增待办';
      this.fetchMiniCompanies(this.currentUser.role);
    },
    watch:{
      miniCompanies(newVal){
        this.item.companyId = newVal[0].value;
      }
    }
  }
</script>

<style scoped>
  .flex {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .spacer {
    flex: 1;
  }

  .compName {
    padding: 0 5px;
  }

  textarea {
    border: none;
    background: rgba(249, 249, 249, 1);
    border-radius: 3px;
    width: 100%;
    height: 300px;
    font-size: 14px;
    font-family: 'microsoft yahei';
    resize: none;
    padding: 5px;
  }
</style>